import { marked } from 'marked';
import DOMPurify from 'dompurify';

function render_markdown(text) {
  const rawHtml = marked.parse(text || '');
  return DOMPurify.sanitize(rawHtml);
}

function escape_html_attr(value) {
  return (
    String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
  );
}

function split2(text, splitter) {
  // Returns [part1, part2]
  const pos = text.indexOf(splitter);
  if (pos < 0) {
    return [text, undefined];
  }
  const head = text.substring(0, pos);
  const tail = text.substring(pos+1);
  return [head, tail];
}

function transition_parser(raw) {
  // raw: "transition_id@JSON"
  // Returns "html data"
  const [trans_id, body] = split2(raw, '@');
  const data = JSON.parse(body);
  const clean_json = escape_html_attr(body);

  let res = [
    `<button class="ai-action" x-transition-id="${trans_id}" x-json="${clean_json}">`,
    "Lanzar acción",
    "</button>",
    "<table><tr><th>",
    "Campo",
    "</th><th>",
    "Valor sugerido",
    "</th></tr>",
    "<tbody>",
  ];
  for (const [key, value] of Object.entries(data)) {
    res.push(`<tr><td>${key}</td><td>${value}</td></tr>`);
  }
  res.push("</tbody></table>");

  return res.join('');
}

const CUSTOM_FLAG = "@!custom_render@SHW5X80Dpp6mqNKW::";

class RenderPipeline {
  constructor(raw) {
    this.raw = raw;
    this.init();
  }

  init() {
    this.custom_render = []; // [render_function()]
  }

  parse() {
    let text = this.raw;
    text = this.parse_qmkey_buttons(text);
    // More parsers here
    let html = render_markdown(text);
    html = this.parse_custom_components(html);
    return html;
  }

  register_component(render_function) {
    /**
     * Returns a FLAG string and registers the component for custom_render
     * The content of the FLAG will be replaced by the HTML of render_function()
     **/
    const index = this.custom_render.length;
    this.custom_render.push(render_function);
    return CUSTOM_FLAG + index + '.';
  }

  parse_custom_components(html) {
    for (let i = 0; i < this.custom_render.length; i++) {
      const render_function = this.custom_render[i];
      const render = render_function();
      html = html.replace(`<p>${CUSTOM_FLAG}${i}.</p>`, render);
    }
    return html;
  }

  render_button(button_text, button_id) {
    // raw: "transition_id@JSON"
    // Returns "html data"
    let res = [
      `<button class="ai-action" data-button-id="${button_id}"">`,
      "Lanzar acción",
      "</button>",
    ];
    return res.join('');
  }

  parse_qmkey_buttons(text) {
    const self = this;
    return text.replace(
      /\[button:([^\]]+)\]\(#QmKey:S8l21NmS:([^)]+)\)/g,
      (match, button_text, button_id) => {
        return self.register_component(
          self.render_button.bind(self, button_text, button_id)
        );
      }
    );
  }
}

export function ai_render(raw) {
  const renderer = new RenderPipeline(raw);
  return renderer.parse();
}
